export const getReloadActionEvent =
() => {
    return () => {
        location.reload();
    }
};
